import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HolidayConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { HolidayService } from './api/holiday.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class HolidayApiModule {
    public static forRoot(configurationFactory: () => HolidayConfiguration): ModuleWithProviders<HolidayApiModule> {
        return {
            ngModule: HolidayApiModule,
            providers: [ { provide: HolidayConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: HolidayApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('HolidayApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
